import { UnhandledStatus, backendApiBaseUrl } from 'libs/api';

export enum FeedbackType {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

export type FeedbackBody = {
  type: FeedbackType;
  email: string;
  message: string;
  path: string;
};

export const sendFeedback = async (body: FeedbackBody): Promise<void> => {
  const response = await fetch(`${backendApiBaseUrl}/feedback`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (response.status !== 201) {
    throw await UnhandledStatus.fromResponse(response);
  }
};
